export interface OfficeUserProfile {
  displayName?: string;
  emailAddress?: string;
}

/**
 * The signed-in mailbox owner's display name / address, straight from
 * Office.js. Returns null outside a mailbox host (dev in a plain browser tab,
 * or before Office.onReady has fired). whoami's `upn` is the reliable fallback.
 */
export function getOfficeUserProfile(): OfficeUserProfile | null {
  const office = (globalThis as { Office?: typeof Office }).Office;
  const profile = office?.context?.mailbox?.userProfile;
  if (!profile) return null;
  return {
    displayName: profile.displayName || undefined,
    emailAddress: profile.emailAddress || undefined,
  };
}
